import { MenuItem, TextField } from '@mui/material'
import { useGridApiContext } from '@mui/x-data-grid-pro'
import React from 'react'

import { editorSx } from './editorStyles'
import type { EditorComponentProps } from './registry'

type Option = { value: string | number; label: string }

export const SelectEditor: React.FC<EditorComponentProps> = (params) => {
	const apiRef = useGridApiContext()
	const options = (params.componentOptions.options ?? []) as Option[]
	const prompt = (params.componentOptions.prompt as string | null | undefined) ?? null
	const placeholder = prompt ?? params.colDef.headerName ?? ''
	const value = (params.value ?? '') as string | number
	return (
		<TextField
			select
			value={value}
			onChange={(e) => apiRef.current.setEditCellValue({ id: params.id, field: params.field, value: e.target.value })}
			size="small"
			fullWidth
			autoFocus
			sx={editorSx}
			SelectProps={{ displayEmpty: true }}
		>
			{placeholder !== '' && (
				<MenuItem value="">
					<em style={{ color: 'rgba(0, 0, 0, 0.4)' }}>{placeholder}</em>
				</MenuItem>
			)}
			{options.map((opt) => (
				<MenuItem key={opt.value} value={opt.value}>
					{opt.label}
				</MenuItem>
			))}
		</TextField>
	)
}
